import { buyerSubmissionKeys } from "./buyerKeys";

/**
 * Query keys for a submission's send history.
 *
 * <p>Built on `buyerSubmissionKeys.all` rather than on a second `["buyers"]`
 * literal, so a submission-level invalidation already covers the history — which
 * is what has to happen, because SENDING is what appends to it and every send
 * mutation already invalidates that prefix.</p>
 *
 * <p>A factory file of its own, not an addition to `buyerKeys.ts`:
 * `staleAfterSaveGate.test.ts` requires `queryKey` literals to live in a
 * `*Keys.ts` file, and this one is owned by the two send tabs.</p>
 */
export const sendVersionKeys = {
  all: () => [...buyerSubmissionKeys.all, "send-history"] as const,

  /** One submission's whole history, both kinds. The read is not split by kind
   *  because the endpoint is not: splitting the key would make two tabs on one
   *  record fetch the same payload twice. */
  forSubmission: (submissionId: string) =>
    [...sendVersionKeys.all(), submissionId] as const,
};
